export interface PaysafeFieldStatus {
  focused: boolean;
  invalid: boolean;
  touched: boolean;
  valid: boolean;
}
